import * as yup from 'yup';
import { TFunction } from 'i18next';
import { StockProductType } from 'types/models/StockReceipt';

export const StockMovementTransferFormSchema = (t: TFunction): any =>
  yup.object().shape({
    venueId: yup.string().required(t('schema.required')),
    sourceId: yup.string().required(t('schema.required')),
    destinationId: yup.string().required(t('schema.required')),
  });

export const StockMovementAdjustmentFormSchema = (t: TFunction): any =>
  yup.object().shape({
    venueId: yup.string().required(t('schema.required')),
    locationId: yup.string().required(t('schema.required')),
    operation: yup.string().required(t('schema.required')),
    reason: yup.string().required(t('schema.required')),
  });

export const StockMovementLossFormSchema = (t: TFunction): any =>
  yup.object().shape({
    venueId: yup.string().required(t('schema.required')),
    locationId: yup.string().required(t('schema.required')),
    reason: yup.string().required(t('schema.required')),
  });

export const StockRecipeFormSchema = (t: TFunction): any =>
  yup.object().shape({
    venueId: yup.string().required(t('schema.required')),
    globalProductId: yup.number().required(t('schema.required')),
  });

export const StockProductionFormSchema = (t: TFunction): any =>
  yup.object().shape({
    venueId: yup.string().required(t('schema.required')),
    recipeId: yup.string().required(t('schema.required')),
    productionCenterId: yup.string().required(t('schema.required')),
    quantity: yup
      .number()
      .required(t('schema.required'))
      .min(1, t('schema.min-1'))
      .max(99999, t('schema.max-quantity')),
  });

export const SupplierFormSchema = (t: TFunction): any =>
  yup.object().shape({
    businessName: yup.string().required(t('schema.required')),
    taxId: yup.string().required(t('schema.required')),
    address: yup.string().required(t('schema.required')),
    phone: yup.string().required(t('schema.required')),
    email: yup.string().required(t('schema.required')),
    venueIds: yup.array().required(t('schema.required')),
    isActive: yup.boolean().required(t('schema.required')),
  });

export const WarehouseFormSchema = (t: TFunction): any =>
  yup.object().shape({
    venueId: yup.string().required(t('schema.required')),
    name: yup.string().required(t('schema.required')).min(3, t('schema.min-3')).max(191, t('schema.max-191')),
    type: yup.string().required(t('schema.required')),
    managerUserId: yup.string().nullable(),
    isActive: yup.boolean().required(t('schema.required')),
  });

export const ProductionCenterFormSchema = (t: TFunction): any =>
  yup.object().shape({
    venueId: yup.string().required(t('schema.required')),
    name: yup.string().required(t('schema.required')).min(3, t('schema.min-3')).max(191, t('schema.max-191')),
    type: yup.string().required(t('schema.required')),
    isActive: yup.boolean().required(t('schema.required')),
  });

//
export const GlobalProductFormSchema = (t: TFunction, isCreate = false): any =>
  yup.object().shape({
    name: yup.string().required(t('schema.required')).max(191, t('schema.max-191')),
    minimumStock: yup
      .number()
      .nullable()
      .min(0, t('schema.min-0'))
      .transform((value) => (value === '' ? null : value)),
    safetyStock: yup
      .number()
      .nullable()
      .min(0, t('schema.min-0'))
      .transform((value) => (value === '' ? null : value)),
    replacementCost: yup
      .number()
      .nullable()
      .min(0, t('schema.min-0'))
      .transform((value) => (value === '' ? null : value)),
    unitMeasure: yup.string().when('type', {
      is: StockProductType.RAW_MATERIAL,
      then: yup.string().required(t('schema.required')),
      otherwise: yup.string().notRequired(),
    }),
    receptionUnitMeasure: yup
      .string()
      .when('type', {
        is: StockProductType.RAW_MATERIAL,
        then: yup.string().required(t('schema.required')),
        otherwise: yup.string().nullable(),
      })
      .nullable(),
    unitsPerReceptionUnit: yup
      .number()
      .nullable()
      .min(0, t('schema.min-0'))
      .transform((value) => (value === '' ? null : value)),
    ...(isCreate
      ? {
          venueId: yup.string().required(t('schema.required')),
          sku: yup.string().required(t('schema.required')).max(191, t('schema.max-191')),
          type: yup.string().required(t('schema.required')),
        }
      : {}),
  });
